import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { RestService } from '../../../core/services/rest.service';
import {
    GrdfAccessRightModel,
    GrdfConsumptionStep,
    GrdfRemoteAccessRightModel,
} from './grdf.models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GrdfService {
    constructor(@Inject(RestService) private restService: RestService) {}

    public async getGrdfRemoteAccessRights(): Promise<GrdfRemoteAccessRightModel[]> {
        const path = '/grdf/remote_access_rights';
        const users = await this.restService.get(path, {});
        return users;
    }
    public async getGrdfAccessRights(): Promise<GrdfAccessRightModel[]> {
        const path = '/grdf/access_rights';
        const users = await this.restService.get(path, {});
        return users;
    }

    public async getGrdfAccessRight(accessRightId: string): Promise<GrdfAccessRightModel> {
        const path = `/grdf/access_right/${accessRightId}`;
        return await this.restService.get(path);
    }

    public async postNewFileProof(accessRightId: string, fileProof: File) {
        const path = `/grdf/access_right/${accessRightId}/proof`;
        const formData = new FormData();
        formData.append('file', fileProof);

        return await this.restService.post(path, {}, formData);
    }

    public async createGrdfAccessRight(
        accessRight: Partial<GrdfAccessRightModel>,
        fileProof?: File | null,
    ): Promise<GrdfAccessRightModel> {
        const path = `/grdf/access_right`;
        const formData = new FormData();

        // Ajouter chaque champ de accessRight à la main
        for (const [key, value] of Object.entries(accessRight)) {
            if (value !== undefined && value !== null) {
                formData.append(
                    key,
                    value instanceof Date ? value.toISOString() : value.toString(),
                );
            }
        }

        // Ajouter le fichier seulement s’il est présent
        if (fileProof) {
            formData.append('file', fileProof);
        }

        return await this.restService.post(path, {}, formData);
    }

    public async deleteGrdfAccessRight(accessRightId: string): Promise<GrdfAccessRightModel> {
        const path = `/grdf/access_right/${accessRightId}`;
        return await this.restService.delete(path);
    }
    public async deleteGrdfAccessRemoteRight(accessRightId: string): Promise<GrdfAccessRightModel> {
        const path = `/grdf/access_right_remote/${accessRightId}`;
        return await this.restService.delete(path);
    }

    public async getTechnicalData(acessRightId: string, forceReload: boolean = false) {
        let path = `/grdf/access_right/${acessRightId}/technical-data`;
        if (forceReload) path += '?forceReload=true';
        return await this.restService.get(path);
    }

    public async getContractualData(acessRightId: string, forceReload: boolean = false) {
        let path = `/grdf/access_right/${acessRightId}/contractual-data`;
        if (forceReload) path += '?forceReload=true';
        return await this.restService.get(path);
    }

    public async getConsumptions(
        acessRightId: string,
        dateStart: Date,
        dateEnd: Date,
        step: GrdfConsumptionStep,
        forceReload: boolean,
    ) {
        const path = `/grdf/access_right/${acessRightId}/consumptions`;
        const queryParams: any = {
            dateStart,
            dateEnd,
            step,
        };
        if (forceReload) {
            queryParams.forceReload = forceReload;
        }
        return await this.restService.get(path, queryParams);
    }

    public getFileProof(
        accessRightId: string,
        type: 'userToThirdParty' | 'userToConsumer',
    ): Observable<HttpResponse<Blob>> {
        const path = `/grdf/access_right/${accessRightId}/proof?type=${type}`;
        return this.restService.download(path, {});
    }
}
